import React from "react";

import { CircularProgress, styled } from '@mui/material';
import { RouteComponentProps, navigate } from "@reach/router";
import { useAppSelector } from "../hooks/redux";
import { RootState } from "../store";
import { AdminRole } from "../types/auth";

const Root = styled('div')({
  width: '100vw',
  height: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

interface PrivateRouteProps extends RouteComponentProps {
  component: any;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ component: Component, location, ...rest }) => {
  const auth = useAppSelector((state: RootState) => state.auth);

  if (auth.userStateLoading || !location) {
    return (
      <Root>
        <CircularProgress size={50} />
      </Root>
    );
  }

  if ((auth.user === null || !auth.user.roles.includes(AdminRole.admin)) && location.pathname !== '/login') {
    navigate('/login');
    return null;
  }

  return <Component {...rest} />

};

export default PrivateRoute;